import React from 'react'
import styled from 'styled-components/native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { useNavigation } from '@react-navigation/native'

import { Images } from 'APP/Themes'
import I18n from 'APP/I18n'
import Button from 'APP/Converse/Button'
import { ResponsiveView } from 'APP/Converse/Layout'
import LogoHeader from 'APP/Components/LogoHeader'

const ScreenContainer = styled(SafeAreaView).attrs({
  edges: ['bottom', 'left', 'right'],
})`
  flex: 1;
`

const ContentContainer = styled(ResponsiveView)`
  gap: ${({ theme }) => theme.metrics.baseMargin * 2}px;
  padding: ${({ theme }) => theme.metrics.baseMargin}px;
`

const ButtonContainer = styled.View`
  gap: ${({ theme }) => theme.metrics.baseMargin}px;
`

function LoginErrorScreen() {
  const navigation = useNavigation()

  return (
    <ScreenContainer>
      <ContentContainer>
        <LogoHeader
          source={Images.logoBlue}
          title={I18n.t('LoginErrorScreen.title')}
          subtitle={I18n.t('LoginErrorScreen.subtitle')}
        />

        <ButtonContainer>
          <Button
            variant="primary"
            widthVariant="full"
            analyticsName="LoginErrorScreen.login"
            title={I18n.t('LoginErrorScreen.login')}
            testID="LOGIN_ERROR_SCREEN_LOGIN_BTN"
            onPress={() => navigation.navigate('welcome', { openUniversalLogin: true })}
          />
        </ButtonContainer>
      </ContentContainer>
    </ScreenContainer>
  )
}

export default LoginErrorScreen
